import { createFileRoute } from "@tanstack/react-router";

import { ServicesPageContent } from "@/components/site/ServicesPageContent";
import { SiteShell } from "@/components/site/SiteShell";
import { business, services } from "@/lib/business";
import { localBusinessJsonLd, pageHead } from "@/lib/seo";

const title = `Engine Machine Services | ${business.name}`;
const description = `Cylinder boring, sleeving, valve seat and guide work, line boring, honing, balancing, lathe work, block & head surfacing, and diesel machining in ${business.city}, ${business.state}. Call ${business.phone} for auto, truck, tractor & motorcycle engine work.`;

export const Route = createFileRoute("/services")({
  component: ServicesPage,
  head: () => ({
    ...pageHead({ title, description, path: "/services" }),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(localBusinessJsonLd(description)),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: title,
          description,
          url: `${business.siteUrl}/services`,
          mainEntity: services.map((service) => ({
            "@type": "Service",
            name: service.title,
            description: service.details,
            provider: {
              "@type": "AutoMachineShop",
              name: business.name,
              telephone: business.phone,
            },
            areaServed: business.areaServed,
          })),
        }),
      },
    ],
  }),
});

function ServicesPage() {
  return (
    <SiteShell>
      <ServicesPageContent />
    </SiteShell>
  );
}
